import { WidgetContainer } from '../../infrastructure/widgets/WidgetContainer';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';
import { Button } from '@/shared/components/ui/Button';
import { useJobs, useJobMutations } from '@/features/scraper/hooks/useJobs';

export const runningJobsConfig: WidgetConfig = {
  id: 'dash-running-jobs',
  title: 'Running Jobs',
  category: 'list',
  description: 'Active lead scraping tasks',
  refreshStrategy: 'interval',
  refreshIntervalMs: 5000,
  defaultSize: { w: 4, h: 4 },
  priority: 5,
};

export function RunningJobsWidget() {
  // Canonical jobs cache (shared with the Scraper console). Polls while mounted.
  const { data: jobs = [], isLoading, isError, error, refetch } = useJobs({ refetchInterval: 5000 });
  const { stopJob } = useJobMutations();

  const activeJobs = jobs.filter((j) => j.status === 'running');

  return (
    <WidgetContainer
      config={runningJobsConfig}
      isLoading={isLoading}
      isError={isError}
      errorMessage={error?.message}
      onRefresh={() => { refetch(); }}
    >
      <div className="flex flex-col gap-2">
        {activeJobs.length > 0 ? (
          activeJobs.map((job) => (
            <div
              key={job.id}
              className="flex items-center justify-between rounded-card-sm border border-outline bg-surface p-3 transition-colors hover:border-primary/40"
            >
              <div className="flex-1 pr-2 overflow-hidden">
                <p className="text-body-sm font-semibold text-on-surface truncate">
                  {job.niche ? `${job.niche} · ${job.location}` : 'Lead scan'}
                </p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="rounded-full bg-success/10 px-2 py-0.5 text-label-caps uppercase text-success">
                    Running
                  </span>
                  <span className="text-body-sm text-on-surface-variant">
                    Found: {job.leads_found || 0}
                  </span>
                </div>
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="text-danger hover:bg-danger/10"
                loading={stopJob.isPending}
                onClick={() => stopJob.mutate(job.id)}
              >
                Stop
              </Button>
            </div>
          ))
        ) : (
          <p className="text-body-sm text-on-surface-variant italic p-4 text-center">
            No active jobs.
          </p>
        )}
      </div>
    </WidgetContainer>
  );
}
